import {
    displayPercentOrNA,
    displayShortDateOrNA
} from '../../utils/Format/Format';

export const afterTaxAverageAnnualTableCardUtil = (gqlResult) => {
    if (!gqlResult) return null;

    const {
        mutualFund: {
            inceptionDate,
            standardPerformanceReturns: {
                returnsAfterTaxesOnDistribution,
                returnsAfterTaxesOnDistributionAndSales
            }
        }
    } = gqlResult;

    const {
        asOfDate,
        oneYearReturn,
        fiveYearReturn,
        tenYearReturn,
        sinceInceptionReturn
    } =
        returnsAfterTaxesOnDistribution || {};
    const {
        oneYearReturn: oneYearReturnOnDistributionAndSales,
        fiveYearReturn: fiveYearReturnOnDistributionAndSales,
        tenYearReturn: tenYearReturnOnDistributionAndSales,
        sinceInceptionReturn: sinceInceptionReturnOnDistributionAndSales
    } =
        returnsAfterTaxesOnDistributionAndSales || {};

    const headers = [
        `As of ${displayShortDateOrNA(asOfDate)}`,
        'Returns after taxes on distributions',
        'Returns after taxes on distributions and sale of fund shares'
    ];
    const returnData = [
        {
            label: '1 Year',
            values: [
                { val1: displayPercentOrNA(oneYearReturn) },
                {
                    val2: displayPercentOrNA(
                        oneYearReturnOnDistributionAndSales
                    )
                }
            ]
        },
        {
            label: '5 Year',
            values: [
                { val1: displayPercentOrNA(fiveYearReturn) },
                {
                    val2: displayPercentOrNA(
                        fiveYearReturnOnDistributionAndSales
                    )
                }
            ]
        },
        {
            label: '10 Year',
            values: [
                { val1: displayPercentOrNA(tenYearReturn) },
                {
                    val2: displayPercentOrNA(
                        tenYearReturnOnDistributionAndSales
                    )
                }
            ]
        },
        {
            label: `Since Inception (${displayShortDateOrNA(inceptionDate)})`,
            values: [
                { val1: displayPercentOrNA(sinceInceptionReturn) },
                {
                    val2: displayPercentOrNA(
                        sinceInceptionReturnOnDistributionAndSales
                    )
                }
            ]
        }
    ];
    return {
        data: returnData,
        headers
    };
};
